// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;

import VendorScriptLoader from "./utility/vendor-script-loader";
// import HeaderNavMenu from './components/global/nav-menu';
import HeaderNav from "./components/header-nav";
import ViewportFlexItems from "./utility/viewport-flex-items";

// Animate on scroll
import AOS from "aos";
import "aos/dist/aos.css";

/**
 * Code-splitting :: Blocks
 *
 * Manages blocks that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerBlocks() {
  if (document.querySelector(".js-example-block")) {
    import("~scripts/blocks/example");
  }
  if (document.querySelector(".block-anchorlinks")) {
    import("~scripts/blocks/anchorlinks");
  }
  if (document.querySelector(".block-bookacall")) {
    import("~scripts/blocks/bookacall");
  }
  if (document.querySelector(".block-calltoaction")) {
    import("~scripts/blocks/calltoaction");
  }
  if (document.querySelector(".block-gradienttextimage")) {
    import("~scripts/blocks/gradienttextimage");
  }

  if (document.querySelector(".block-homepage-hero")) {
    import("~scripts/blocks/homepagehero");
  }

  if (document.querySelector(".block-horizontaliconslist")) {
    import("~scripts/blocks/horizontaliconslist");
  }

  if (document.querySelector(".team-member-feed")) {
    import("~scripts/blocks/team-member-feed");
  }

  if (document.querySelector(".js-testimonial-block")) {
    import("~scripts/blocks/testimonial");
  }

  if (document.querySelector(".js-faqs-block")) {
    import("~scripts/blocks/faqs");
  }

  if (document.querySelector(".js-individual-cells-carousel-block")) {
    import("~scripts/blocks/individual-cells-carousel");
  }

  if (document.querySelector(".js-services-block")) {
    import("~scripts/blocks/services");
  }

  if (document.querySelector(".block-button")) {
    import("~scripts/blocks/button-block");
  }

  if (document.querySelector(".block-image-column")) {
    import("~scripts/blocks/image-block");
  }

  // if ( document.querySelector('.js-map') ) {
  //   // Loads component only after vendor file is loaded
  //   document.addEventListener('google-maps:loaded', () => {
  //     // alert('Google Maps loaded');
  //   });

  //   VendorScriptLoader.outputGoogleMapsScriptTag();
  // }

  if (document.querySelector("#feed") !== null) {
    document.addEventListener("multiple-vendors:loaded", () => {
      import("./blocks/feed/index.js");
    });

    VendorScriptLoader.outputVendorScriptTags(["vendor-vue", "vendor-vuex"]);
  }

  if (document.querySelector("#drug-discovery") !== null) {
    document.addEventListener("vendor-vue:loaded", () => {
      import("./blocks/drug-discovery");
    });

    VendorScriptLoader.outputVendorScriptTag("vendor-vue");
  }

  if (document.querySelector(".block-iconsandtext")) {
    import("~scripts/blocks/iconsandtext");
  }

  if (document.querySelector(".block-image")) {
    import("~scripts/blocks/image");
  }
  if (document.querySelector(".block-introtext")) {
    import("~scripts/blocks/introtext");
  }
  if (document.querySelector(".block-standard-hero")) {
    import("~scripts/blocks/standardhero");
  }
  if (document.querySelector(".block-textimage")) {
    import("~scripts/blocks/textimage");
  }
  if (document.querySelector(".block-stepsprocess")) {
    import("~scripts/blocks/stepsprocess");
  }
  if (document.querySelector(".block-statistics")) {
    import("~scripts/blocks/statistics");
  }
  if (document.querySelector(".block-verticaliconslist")) {
    import("~scripts/blocks/verticaliconslist");
  }
  if (document.querySelector(".block-cpt-feed-preview")) {
    import("~scripts/blocks/cpt-feed-preview");
  }
  if (document.querySelector(".block-blog-feed-preview")) {
    import("~scripts/blocks/blog-feed-preview");
  }
  if (document.querySelector(".block-contact-information")) {
    import("~scripts/blocks/contact-information");
  }
  if (document.querySelector(".js-map")) {
    import("~scripts/blocks/map");
    // Loads component only after vendor file is loaded
    document.addEventListener("google-maps:loaded", () => {
      // alert('Google Maps loaded');
    });
    VendorScriptLoader.outputGoogleMapsScriptTag();
  }
}

/**
 * Code-splitting :: Components
 *
 * Manages components that should load dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerComponents() {
  // if ( document.querySelector('.js-example-component') ) {
  //   // Loads component only after vendor file is loaded
  //   document.addEventListener('vendor-vue:loaded', () => {
  //     import('~scripts/components/example');
  //   });
  //
  //   VendorScriptLoader.outputVendorScriptTag('vendor-vue');
  // }

  if (document.querySelector(".js-popup")) {
    import("~scripts/components/global/popup").then((component) => {
      component.default.init();
    });
  }

  if (document.querySelector("lottie-player")) {
    document.addEventListener("vendor-lottie:loaded", () => {
      import("~scripts/utility/lottie");
    });

    VendorScriptLoader.outputVendorScriptTag("vendor-lottie");
  }
}

/**
 * Code-splitting :: Template pages
 *
 * Loads styles for specific template pages dynamically (only when they exist in the DOM)
 * using Webpack's code-splitting feature.
 */
function registerTemplatePages() {}

/**
 * DOMContentLoaded events should be listened to on this file only.
 */
document.addEventListener("DOMContentLoaded", registerBlocks);
document.addEventListener("DOMContentLoaded", registerComponents);
document.addEventListener("DOMContentLoaded", registerTemplatePages);

/**
 * Load common components here
 */
document.addEventListener("DOMContentLoaded", () => {
  // Initiates Header Nav Menu
  AOS.init({
    disable: "mobile",
    once: true,
    duration: 1000,
  });
  setTimeout(() => {
    AOS.refresh();
  }, 500);
  // HeaderNavMenu.init();
  HeaderNav.init();

  // Initialises positioning fix for elements on mobile browsers
  ViewportFlexItems.init();
});
